
import { v4 as uuidv4 } from "uuid";

import CommonUtilities from "@utilities/common_utilities";
import { CommonUtilitiesClass } from "@utilities/common_utilities_class";

export class DiceRoll {
  true_id: string;
  size: number;
  count: number;

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    this.size = obj ? +obj.size : 4;
    this.count = obj ? +obj.count : 0;
    if (obj && obj.log) {
      console.log(obj);
      console.log(this);
    }
    this.common_util = CommonUtilities.getInstance();
  }

  common_util: CommonUtilitiesClass;

  toDBObj(): any {
    return {
      true_id: this.true_id,
      size: this.size,
      count: this.count,
    };
  }

  get_roll(): number[] {
    const results: number[] = [];
    if (this.size === 1) {
      results.push(this.count);
    } else {
      let count = this.count;
      let reverse = false;
      if (count < 0) {
        count *= -1;
        reverse = true;
      }
      for (let i = 0; i < count; ++i) {
        const roll = this.common_util.get_random(this.size);
        if (reverse) {
          results.push(-1 * roll);
        } else {
          results.push(roll);
        }
      }
    }
    return results;
  }

  copy(copyMe: DiceRoll, drop_ids: boolean): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.size = copyMe.size;
    this.count = copyMe.count;
  }

  clone(drop_ids: boolean): DiceRoll {
    const new_obj = new DiceRoll();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  clean() {
    if (this.count === 0 && this.size !== 0) {
      this.size = 0;
    }
    if (this.size === 0 && this.count !== 0) {
      this.count = 0;
    }
  }
}